import { useState, forwardRef } from 'react';
import { Input } from './ui/input';
import { Eye, EyeOff } from 'lucide-react';

// 2026-06-09 — Forward ref so callers can read the DOM value directly on
// submit. This is required for the login race fix: browser autofill and
// password managers populate `input.value` before React's onChange has
// propagated to controlled state, so reading via ref is the only safe way
// to capture what's actually in the field at submit time.
export const PasswordInput = forwardRef(function PasswordInput({ className = '', ...props }, ref) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? 'text' : 'password'}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow(s => !s)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
        data-testid={`toggle-password-${props.id || props['data-testid'] || 'default'}`}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
